'use client';

import { c as _c } from "react/compiler-runtime";
import { authClient } from '@/lib/better-auth/auth-client';
import { zodResolver } from '@hookform/resolvers/zod';
import { ArrowLeft, ArrowRight, Mail, MailCheck } from 'lucide-react';
import Link from 'next/link';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { z } from 'zod';
const ForgotPasswordSchema = z.object({
  email: z.email()
});
type ForgotPasswordSchemaType = z.infer<typeof ForgotPasswordSchema>;
export const ForgotPasswordForm = () => {
  const $ = _c(43);
  const [sentTo, setSentTo] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      resolver: zodResolver(ForgotPasswordSchema),
      mode: "onChange"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    register,
    handleSubmit,
    formState: t1,
    setError
  } = useForm(t0);
  const {
    errors,
    isSubmitting
  } = t1;
  let t2;
  if ($[1] !== setError) {
    t2 = async formData => {
      const {
        error
      } = await authClient.requestPasswordReset({
        email: formData.email,
        redirectTo: `${window.location.origin}/admin/auth/reset-password`
      });
      if (error) {
        setError("root", {
          message: error.message ?? "Could not send reset email. Please try again."
        });
        return;
      }
      setSentTo(formData.email);
    };
    $[1] = setError;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onSubmit = t2;
  if (sentTo) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex size-[52px] items-center justify-center rounded-full bg-[#f1ebfd]"><MailCheck className="size-6 text-[#6c3cd9]" /></div>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <h1 className="text-[26px] font-bold tracking-[-0.52px] text-[#161320]">Check your email</h1>;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== sentTo) {
      t5 = <div className="flex flex-col gap-[6px]">{t4}<p className="text-[14px] leading-[1.5] text-[#8b86a0]">If an account exists for{" "}<span className="font-semibold text-[#161320]">{sentTo}</span>, we’ve sent a link to reset your password.</p></div>;
      $[5] = sentTo;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Link href="/admin/auth/login" className="flex items-center gap-[8px] text-[13.5px] font-semibold text-[#6c3cd9] hover:underline"><ArrowLeft className="size-[16px] shrink-0" />Back to sign in</Link>;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    let t7;
    if ($[8] !== t5) {
      t7 = <div className="flex flex-col gap-[24px]">{t3}{t5}{t6}</div>;
      $[8] = t5;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    return t7;
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-[6px]"><h1 className="text-[26px] font-bold tracking-[-0.52px] text-[#161320]">Forgot your password?</h1><p className="text-[14px] text-[#8b86a0]">Enter your email and we’ll send you a link to reset it.</p></div>;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== handleSubmit || $[12] !== onSubmit) {
    t4 = handleSubmit(onSubmit);
    $[11] = handleSubmit;
    $[12] = onSubmit;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <label className="text-[13.5px] font-semibold tracking-[-0.135px] text-[#161320]">Email</label>;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Mail className="absolute left-[14px] top-1/2 size-[15px] -translate-y-1/2 text-[#8b86a0]" />;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== register) {
    t7 = register("email");
    $[16] = register;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = <div className="relative">{t6}<input {...t7} type="email" placeholder="admin@noctocode.com" className="h-[48px] w-full rounded-[14px] border border-[#e7e4ef] bg-[#f8f7fb] pl-[40px] pr-[14px] text-[14px] tracking-[-0.084px] text-[#161320] outline-none placeholder:text-[#c4bfd6] focus:border-[#6c3cd9]" /></div>;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== errors.email) {
    t9 = errors.email && <p className="text-[12px] text-[#e11d48]">{errors.email.message}</p>;
    $[20] = errors.email;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = <div className="flex flex-col gap-[6px]">{t5}{t8}{t9}</div>;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== errors.root) {
    t11 = errors.root && <p className="text-[13px] text-[#e11d48]">{errors.root.message}</p>;
    $[25] = errors.root;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const t12 = isSubmitting ? "Sending\u2026" : "Send reset link";
  let t13;
  if ($[27] !== t12) {
    t13 = <span className="text-[15px] font-semibold tracking-[-0.15px] text-white">{t12}</span>;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== isSubmitting) {
    t14 = !isSubmitting && <ArrowRight className="size-[16px] text-white" />;
    $[29] = isSubmitting;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== isSubmitting || $[32] !== t13 || $[33] !== t14) {
    t15 = <button type="submit" disabled={isSubmitting} className="mt-[4px] flex h-[50px] w-full cursor-pointer items-center justify-center gap-[8px] rounded-[14px] bg-[#6c3cd9] transition-opacity hover:opacity-90 disabled:opacity-60">{t13}{t14}</button>;
    $[31] = isSubmitting;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t15 || $[38] !== t4) {
    t16 = <form onSubmit={t4} className="flex flex-col gap-[16px]">{t10}{t11}{t15}</form>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t15;
    $[38] = t4;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Link href="/admin/auth/login" className="flex items-center justify-center gap-[8px] text-[13.5px] font-semibold text-[#6c3cd9] hover:underline"><ArrowLeft className="size-[16px] shrink-0" />Back to sign in</Link>;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t16) {
    t18 = <div className="flex flex-col gap-[28px]">{t3}{t16}{t17}</div>;
    $[41] = t16;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
};